letterAdjust.scale = 0.9;
// Colors are in order like this...  home: [ inside, outline, outline2, outline3 ]
var font = {
    "0": "M129 -118v1035l148 148h399l148 -148v-1035l-148 -148h-399zM321 -38l36 -37h240l35 37v875l-35 36h-240l-36 -36v-875z",
    "1": "M131 -75h74v835h-74v157l133 148h132v-1140h75v-191h-340v191z",
    "2": "M131 -266v614l147 147h320l36 36v306l-36 36h-240l-36 -36v-113h-191v193l147 148h399l149 -148v-466l-149 -147h-319l-36 -36v-343h312v150h192v-341h-695z",
    "3": "M129 75h192v-113l36 -37h240l35 37v306l-35 36h-198v191h198l35 36v306l-35 36h-240l-36 -36v-113h-192v193l148 148h399l148 -148v-439l-78 -79l78 -78v-439l-148 -148h-399l-148 148v193z",
    "4": "M61 304l357 761h276v-799h107v-191h-107v-150h107v-191h-407v191h108v150h-397zM257 266h245v523z",
    "5": "M133 75h192v-113l36 -37h240l35 37v306l-35 36h-320l-148 147v614h695v-192h-503v-342l36 -36h320l147 -147v-466l-147 -148h-400l-148 148v193z",
    "6": "M129 -118v1035l148 148h399l148 -148v-193h-192v113l-35 36h-240l-36 -36v-342h355l148 -147v-466l-148 -148h-399zM321 -38l36 -37h240l35 37v306l-35 36h-276v-342z",
    "7": "M124 724v341h648l47 -256l-317 -884h68v-191h-340v191h68l322 902l-8 46h-297v-149h-191z",
    "8": "M129 -118v439l78 78l-78 79v439l148 148h399l148 -148v-439l-78 -79l78 -78v-439l-148 -148h-399zM321 -38l36 -37h240l35 37v306l-35 36h-240l-36 -36v-306zM321 531l36 -36h240l35 36v306l-35 36h-240l-36 -36v-306z",
    "9": "M129 75h192v-113l36 -37h240l35 37v342h-355l-148 147v466l148 148h399l148 -148v-1035l-148 -148h-399l-148 148v193zM321 531l36 -36h275v342l-35 36h-240l-36 -36v-306z",
    "A": "M103 -266l152 1331h360l153 -1331h-200l-38 323h-189l-39 -323h-199zM363 257h144l-71 608z",
    "B": "M133 -266v1331h543l123 -124v-442l-100 -100l100 -99v-444l-123 -122h-543zM333 -66h266v366h-266v-366zM333 499h266v366h-266v-366z",
    "C": "M129 -142v1083l124 124h419l123 -124v-262h-200v186h-266v-931h266v186h200v-262l-123 -124h-419z",
    "D": "M133 -266v1331h543l123 -123v-1086l-123 -122h-543zM333 -66h266v931h-266v-931z",
    "E": "M133 -266v1331h666v-200h-466v-366h266v-199h-266v-366h466v-200h-666z",
    "F": "M133 -266v1331h666v-200h-466v-366h266v-199h-266v-566h-200z",
    "G": "M129 -144v1086l124 123h419l123 -123v-263h-200v186h-266v-931h266v366h-133v199h333v-643l-123 -122h-419z",
    "H": "M133 -266v1331h200v-566h266v566h200v-1331h-200v566h-266v-566h-200z",
    "I": "M133 -266v1331h200v-1331h-200z",
    "J": "M73 120h200v-186h266v1131h200v-1207l-124 -124h-418l-124 124v262z",
    "K": "M133 -266v1331h200v-412l235 412h231l-304 -530l304 -801h-213l-219 576l-34 -60v-516h-200z",
    "L": "M133 -266v1331h200v-1131h466v-200h-666z",
    "M": "M133 -266v1331h200l133 -386l133 386h200v-1331h-200v765l-133 -379l-133 379v-765h-200z",
    "N": "M133 -266v1331h200l266 -760v760h200v-1331h-200l-266 760v-760h-200z",
    "O": "M129 -144v1086l124 123h418l124 -123v-1086l-124 -122h-418zM329 -66h266v931h-266v-931z",
    "P": "M133 -266v1331h543l123 -124v-518l-123 -123h-343v-566h-200zM333 499h266v366h-266v-366z",
    "Q": "M129 -142v1084l123 123h419l124 -123v-1084l-100 -100l80 -145h-156l-67 121h-300zM329 -66h266v931h-266v-931z",
    "R": "M133 -266v1331h543l123 -124v-518l-123 -123l123 -566h-207l-123 566h-136v-566h-200zM333 499h266v366h-266v-366z",
    "S": "M129 120h200v-186h266v366h-343l-123 123v518l123 124h419l124 -124v-262h-200v186h-266v-366h342l124 -122v-521l-124 -122h-419l-123 122v264z",
    "T": "M118 865v200h666v-200h-233v-1131h-199v1131h-234z",
    "U": "M133 -144v1209h200v-1131h266v1131h200v-1209l-123 -122h-419z",
    "V": "M114 1065h200l133 -888l133 888h200l-200 -1331h-266z",
    "W": "M114 1065h200l120 -797l113 404l113 -404l120 797h200l-200 -1331h-182l-51 294l-50 -294h-183z",
    "X": "M124 -266l233 665l-233 666h200l132 -381l134 381h199l-233 -666l233 -665h-199l-134 380l-132 -380h-200z",
    "Y": "M108 1065h212l121 -346l121 346h212l-234 -666v-665h-199v665z",
    "Z": "M133 -66l466 931h-466v200h666v-200l-466 -931h466v-200h-666v200z"
};
var font_size = 24,
    st_louis = true
tracking = 2,
    panel_Hor_Adjustment = 0,
    font_Top_Adjustment = -15.5,
    middleSplitAdjustment = -0.5,
    middleSpreadAdjustment = {
        left: 1,
        right: 1
    },
    small_Caps_Adjustment = {
        vertical: -180,
        horizontal: 0,
        scale_width: 0, // effects period
        scale_height: 0, // effects period
    },
    colors = {
        characters: {
            home: [
                "#dca22a", // gold
            ],
            away: [
                 "#0069ad", // light Blue
            ],
          	third: [
                "#e8e8e8", // like white
            ]
        },
        numbers: {
            home: [
                "#dca22a", // White
                // "#011E41", // black
                // "#FFB71B", // Yellow
            ],
            away: [
                "#0069ad", // Light Blue
                // "#FFB71B", // Yellow
                // "#011E41", // black
            ],
          	third: [
                "#dbdbdb", // white
                "#071b38", //    blue
                "#dfa020", //    yellow
            ]
        }
    },
    outlines = {
        characters: {
            width: 1.5
        },
        numbers: {
            width: 2.5
        }
    },
    special_Character_Adjustments = {
        period: {
            vertical: 0.5, // this moves it up from the bottom
            horizontal: 3,
            scale_width: 12.5,
            scale_height: 12.5,
        },
        hyphen: {
            vertical: -6,
            horizontal: -5.5,
            scale_width: 0,
            scale_height: -3,
        },
        apostrophe: {
            vertical: 0.25, // this is backwards
            horizontal: -1,
            scale_width: 0,
            scale_height: 0,
        }
    },
    number_Adjustments = {
        top: 11,
        left: -5,
        width: 92,
        height: 75,
        middle_Space: 6,
        oneOffset: 7
    };
